import React from "react";
import { PaginatedResponse } from "src/types";

import { AnnouncementSubscriber, fetchSubscribers, FetchSubscribersPayload } from "@admin/api/announcements";
import { showErrorToast } from "@shared/toasts/Toasts";

export const useFetchSubscribers = (payload?: FetchSubscribersPayload) => {
    const [data, setData] = React.useState<PaginatedResponse<AnnouncementSubscriber> | null>(null);
    const [isLoading, setIsLoading] = React.useState(false);

    const refetch = React.useCallback(() => {
        setIsLoading(true);

        void fetchSubscribers(payload)
            .then((response) => setData(response))
            .catch((error) => {
                const err = error as Error;
                showErrorToast(err.message);
            })
            .finally(() => setIsLoading(false));
    }, [payload?.email, payload?.pageIndex, payload?.pageSize, payload?.sortCriteria, payload?.sortDirection]);

    React.useLayoutEffect(() => {
        refetch();
    }, [refetch]);

    return { data, isLoading, refetch };
};
